import type { Movie, Category } from './types';

export const categories: Category[] = [
  { slug: 'dianying', name: '电影', icon: 'ri-film-line', description: '最新高清电影，动作、喜剧、科幻、爱情等类型一网打尽' },
  { slug: 'dianshiju', name: '电视剧', icon: 'ri-tv-line', description: '热门电视剧全集免费在线观看，每日更新' },
  { slug: 'zongyi', name: '综艺', icon: 'ri-live-line', description: '热门综艺节目高清在线，欢乐不断' },
  { slug: 'dongman', name: '动漫', icon: 'ri-artboard-line', description: '日本动漫、国产动漫高清在线看' },
  { slug: 'jilupian', name: '纪录片', icon: 'ri-camera-lens-line', description: '精品纪录片，探索世界奥秘' },
];

export const movies: Movie[] = [
  {
    id: 'movie-1',
    title: '流浪地球3',
    englishTitle: 'The Wandering Earth 3',
    category: 'dianying',
    year: 2026,
    rating: 8.8,
    region: '中国大陆',
    director: '郭帆',
    cast: ['吴京', '刘德华', '李雪健', '沙溢', '宁理'],
    duration: '150分钟',
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。然而宇宙之路危机四伏，为了拯救地球，流浪地球时代的年轻人再次挺身而出，展开争分夺秒的生死之战。人类命运共同体的宏大叙事与个体生命的温暖情感交织在一起，呈现出一场震撼人心的科幻史诗。',
    coverImage: 'https://readdy.ai/api/search-image?query=Cinematic%20futuristic%20sci-fi%20movie%20poster%20style%2C%20giant%20Earth%20engines%20in%20space%2C%20epic%20dramatic%20lighting%20with%20orange%20and%20dark%20tones%2C%20cinematic%20composition%2C%20professional%20movie%20art%20style%20with%20atmospheric%20glow&width=840&height=470&seq=movie-1-cover&orientation=landscape',
    posterImage: 'https://readdy.ai/api/search-image?query=Vertical%20movie%20poster%20style%2C%20futuristic%20sci-fi%20theme%2C%20dramatic%20orange%20and%20black%20tones%2C%20cinematic%20lighting%20effect%2C%20minimal%20clean%20composition%20with%20dark%20background&width=600&height=840&seq=movie-1-poster&orientation=portrait',
    tags: ['科幻', '冒险', '灾难'],
    updateTime: '2026-07-28',
    isHot: true,
    isNew: true,
    views: 1258000,
  },
  {
    id: 'movie-2',
    title: '长安三万里2',
    englishTitle: "Chang'an 2",
    category: 'dongman',
    year: 2026,
    rating: 9.0,
    region: '中国大陆',
    director: '谢君伟',
    cast: ['杨天翔', '凌振赫'],
    duration: '138分钟',
    description: '安史之乱后，高适与李白的人生轨迹走向不同命运。一个在边塞浴血奋战，一个在江南流离失所。两个伟大灵魂在乱世中的坚守与抉择，谱写出大唐盛世下一段荡气回肠的史诗篇章。',
    coverImage: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20Dynasty%20animation%20movie%20style%2C%20traditional%20ink%20painting%20aesthetic%2C%20warm%20golden%20and%20red%20tones%2C%20poetic%20atmospheric%20scene%20with%20classical%20Chinese%20architecture%20and%20nature&width=840&height=470&seq=movie-2-cover&orientation=landscape',
    posterImage: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20movie%20poster%2C%20Tang%20Dynasty%20style%2C%20traditional%20ink%20brush%20art%2C%20warm%20golden%20amber%20tones%2C%20elegant%20classical%20composition%20with%20minimal%20background&width=600&height=840&seq=movie-2-poster&orientation=portrait',
    tags: ['动画', '历史', '诗词'],
    updateTime: '2026-07-25',
    isHot: true,
    isNew: false,
    views: 980000,
  },
  {
    id: 'movie-3',
    title: '暗夜追凶',
    englishTitle: 'Night Pursuit',
    category: 'dianying',
    year: 2026,
    rating: 8.5,
    region: '中国香港',
    director: '邱礼涛',
    cast: ['古天乐', '刘青云', '吴镇宇'],
    duration: '118分钟',
    description: '一起离奇的连环杀人案，让三位警探走到一起。凶手留下的线索扑朔迷离，每一次接近真相，都伴随着更大的危险。当正义与黑暗的边界变得模糊，他们将如何抉择？',
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20crime%20thriller%20movie%20style%2C%20noir%20atmospheric%20lighting%2C%20rainy%20city%20night%20scene%2C%20detective%20theme%2C%20intense%20dramatic%20composition%20with%20deep%20shadows%20and%20neon%20accents&width=840&height=470&seq=movie-3-cover&orientation=landscape',
    posterImage: 'https://readdy.ai/api/search-image?query=Crime%20thriller%20movie%20poster%2C%20noir%20style%2C%20dark%20rainy%20night%20atmosphere%2C%20dramatic%20shadow%20lighting%2C%20minimal%20composition%20with%20mysterious%20dark%20background&width=600&height=840&seq=movie-3-poster&orientation=portrait',
    tags: ['悬疑', '犯罪', '动作'],
    updateTime: '2026-07-22',
    isHot: true,
    isNew: false,
    views: 756000,
  },
  {
    id: 'movie-4',
    title: '繁花似锦',
    englishTitle: 'Blooming Flowers',
    category: 'dianshiju',
    year: 2026,
    rating: 8.9,
    region: '中国大陆',
    director: '汪俊',
    cast: ['刘亦菲', '陈晓', '林更新', '柳岩'],
    duration: '45分钟/集',
    description: '讲述了上世纪九十年代，几个年轻人在大城市打拼创业的故事。他们怀揣梦想，经历挫折与成长，在时代的浪潮中寻找属于自己的位置，展现了改革开放大背景下小人物的奋斗史诗。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20TV%20series%20style%2C%201990s%20Chinese%20city%20aesthetic%2C%20warm%20nostalgic%20golden%20tone%2C%20romantic%20atmospheric%20scene%20with%20retro%20urban%20elements&width=840&height=470&seq=movie-4-cover&orientation=landscape',
    posterImage: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20poster%2C%20romantic%201990s%20style%2C%20warm%20nostalgic%20tone%2C%20elegant%20minimal%20portrait%20composition%20with%20soft%20lighting&width=600&height=840&seq=movie-4-poster&orientation=portrait',
    tags: ['都市', '爱情', '年代'],
    updateTime: '2026-07-30',
    isHot: true,
    isNew: true,
    views: 2100000,
  },
  {
    id: 'movie-5',
    title: '极限挑战第十季',
    englishTitle: 'Go Fighting S10',
    category: 'zongyi',
    year: 2026,
    rating: 8.2,
    region: '中国大陆',
    director: '严敏',
    cast: ['黄渤', '黄磊', '张艺兴', '王迅', '迪丽热巴'],
    duration: '90分钟/期',
    description: '极限男人帮再度集结，开启全新的户外挑战之旅！本季节目走遍中国大好河山，在各地完成趣味十足又充满挑战的任务，带给观众无限欢笑与感动。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20style%2C%20outdoor%20adventure%20theme%2C%20bright%20energetic%20atmosphere%2C%20colorful%20playful%20scene%20with%20natural%20landscape%20and%20team%20spirit&width=840&height=470&seq=movie-5-cover&orientation=landscape',
    posterImage: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%2C%20outdoor%20adventure%20theme%2C%20bright%20energetic%20composition%2C%20colorful%20minimal%20design%20with%20fun%20vibes&width=600&height=840&seq=movie-5-poster&orientation=portrait',
    tags: ['真人秀', '户外', '搞笑'],
    updateTime: '2026-07-29',
    isHot: false,
    isNew: true,
    views: 1580000,
  },
  {
    id: 'movie-6',
    title: '深海探秘',
    englishTitle: 'Deep Sea Quest',
    category: 'jilupian',
    year: 2026,
    rating: 9.2,
    region: '英国',
    director: 'David Attenborough',
    cast: ['David Attenborough'],
    duration: '90分钟',
    description: '跟随世界顶级自然纪录片团队，潜入从未有人涉足的深海世界。在这里，你将见到地球上最神秘的生物，探索最壮丽的海底奇观。每一帧画面都是对生命奇迹的致敬。',
    coverImage: 'https://readdy.ai/api/search-image?query=Nature%20documentary%20style%2C%20deep%20ocean%20exploration%2C%20bioluminescent%20sea%20creatures%2C%20dark%20blue%20underwater%20atmosphere%20with%20mysterious%20light%20beams%2C%20cinematic%20documentary%20photography&width=840&height=470&seq=movie-6-cover&orientation=landscape',
    posterImage: 'https://readdy.ai/api/search-image?query=Nature%20documentary%20poster%2C%20deep%20ocean%20theme%2C%20bioluminescent%20creatures%2C%20dark%20blue%20underwater%20scene%2C%20minimal%20mysterious%20composition&width=600&height=840&seq=movie-6-poster&orientation=portrait',
    tags: ['自然', '海洋', '探索'],
    updateTime: '2026-07-20',
    isHot: false,
    isNew: false,
    views: 520000,
  },
  {
    id: 'movie-7',
    title: '武林外传之风云再起',
    englishTitle: 'My Own Swordsman Returns',
    category: 'dianshiju',
    year: 2026,
    rating: 8.7,
    region: '中国大陆',
    director: '尚敬',
    cast: ['闫妮', '沙溢', '姚晨', '喻恩泰', '姜超'],
    duration: '42分钟/集',
    description: '同福客栈重新开张！佟湘玉、白展堂、郭芙蓉、吕秀才、李大嘴原班人马再度集结。江湖风云变幻，不变的却是同福客栈里的欢声笑语与人间温情。经典回归，笑料加倍。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20costume%20comedy%20TV%20series%20style%2C%20traditional%20Chinese%20inn%20setting%2C%20warm%20playful%20atmosphere%2C%20bright%20colorful%20ancient%20Chinese%20architecture%20with%20comedic%20vibe&width=840&height=470&seq=movie-7-cover&orientation=landscape',
    posterImage: 'https://readdy.ai/api/search-image?query=Chinese%20costume%20comedy%20poster%2C%20traditional%20inn%20theme%2C%20warm%20playful%20tone%2C%20bright%20minimal%20Chinese%20style%20composition&width=600&height=840&seq=movie-7-poster&orientation=portrait',
    tags: ['喜剧', '古装', '经典'],
    updateTime: '2026-08-01',
    isHot: true,
    isNew: true,
    views: 1850000,
  },
  {
    id: 'movie-8',
    title: '星际穿越2：新纪元',
    englishTitle: 'Interstellar: New Era',
    category: 'dianying',
    year: 2026,
    rating: 9.1,
    region: '美国',
    director: 'Christopher Nolan',
    cast: ['Matthew McConaughey', 'Anne Hathaway', 'Timothée Chalamet'],
    duration: '165分钟',
    description: '人类在新家园建立文明后，发现宇宙深处还有更加惊人的秘密。库珀的女儿墨菲留下的数据揭示了另一个维度存在的证据。新一代宇航员踏上新的星际旅程，这一次，他们要面对的不再是黑洞，而是时间本身。',
    coverImage: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20style%2C%20deep%20space%20wormhole%20visual%2C%20stunning%20cosmic%20landscape%2C%20dramatic%20orange%20and%20black%20space%20tones%2C%20cinematic%20interstellar%20travel%20scene&width=840&height=470&seq=movie-8-cover&orientation=landscape',
    posterImage: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20poster%2C%20deep%20space%20theme%2C%20dramatic%20cosmic%20visuals%2C%20dark%20atmospheric%20composition%20with%20stunning%20nebula%20colors&width=600&height=840&seq=movie-8-poster&orientation=portrait',
    tags: ['科幻', '冒险', '太空'],
    updateTime: '2026-07-18',
    isHot: false,
    isNew: false,
    views: 3200000,
  },
  {
    id: 'movie-9',
    title: '长安诡事录',
    englishTitle: 'Mysteries of Chang\'an',
    category: 'dianshiju',
    year: 2026,
    rating: 8.6,
    region: '中国大陆',
    director: '曹盾',
    cast: ['雷佳音', '易烊千玺', '张子枫'],
    duration: '50分钟/集',
    description: '大唐长安城内，一系列离奇案件接连发生。年轻的大理寺少卿与神秘女仵作携手破案，揭开层层迷雾背后隐藏的巨大阴谋。古装悬疑力作，每一集都是一场烧脑之旅。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20mystery%20drama%20style%2C%20ancient%20Tang%20Dynasty%20city%20at%20night%2C%20suspenseful%20atmosphere%2C%20red%20lanterns%20and%20dark%20shadows%2C%20cinematic%20period%20detective%20scene&width=840&height=470&seq=movie-9-cover&orientation=landscape',
    posterImage: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20mystery%20poster%2C%20Tang%20Dynasty%20detective%20theme%2C%20dark%20suspenseful%20red%20and%20black%20tones%2C%20minimal%20atmospheric%20composition&width=600&height=840&seq=movie-9-poster&orientation=portrait',
    tags: ['悬疑', '古装', '探案'],
    updateTime: '2026-08-02',
    isHot: true,
    isNew: true,
    views: 1320000,
  },
  {
    id: 'movie-10',
    title: '人生一串第四季',
    englishTitle: 'The Story of Chuan\'er S4',
    category: 'jilupian',
    year: 2026,
    rating: 9.3,
    region: '中国大陆',
    director: '陈英杰',
    cast: [],
    duration: '30分钟/集',
    description: '走遍中国各地，寻找最地道、最有烟火气的烧烤美食。从东北到海南，从新疆到上海，每一串烤肉背后都有一个动人的故事。深夜放毒系列，建议吃饱再看。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20food%20documentary%20style%2C%20night%20street%20BBQ%20scene%2C%20warm%20golden%20fire%20light%2C%20mouthwatering%20grilled%20skewers%20with%20smoke%2C%20atmospheric%20Chinese%20night%20market%20photography&width=840&height=470&seq=movie-10-cover&orientation=landscape',
    posterImage: 'https://readdy.ai/api/search-image?query=Chinese%20food%20documentary%20poster%2C%20night%20BBQ%20theme%2C%20warm%20golden%20fire%20tones%2C%20appetizing%20minimal%20food%20composition&width=600&height=840&seq=movie-10-poster&orientation=portrait',
    tags: ['美食', '人文', '纪实'],
    updateTime: '2026-07-15',
    isHot: false,
    isNew: false,
    views: 890000,
  },
  {
    id: 'movie-11',
    title: '凡人修仙传',
    englishTitle: 'A Mortal\'s Journey to Immortality',
    category: 'dongman',
    year: 2026,
    rating: 8.9,
    region: '中国大陆',
    director: '陈柏言',
    cast: ['张杰', '宝木中阳'],
    duration: '25分钟/集',
    description: '一个普通的山村少年韩立，偶然踏入修仙世界。没有逆天资质，没有神秘背景，凭借谨慎的性格和过人的心智，在残酷的修真世界一步步变强。国产动画巅峰之作，特效炸裂。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20cultivation%20animation%20style%2C%20fantasy%20martial%20arts%20world%2C%20ethereal%20misty%20mountains%2C%20magical%20glowing%20effects%2C%20epic%20oriental%20fantasy%20atmosphere%20with%20warm%20golden%20light&width=840&height=470&seq=movie-11-cover&orientation=landscape',
    posterImage: 'https://readdy.ai/api/search-image?query=Chinese%20cultivation%20animation%20poster%2C%20fantasy%20martial%20arts%20theme%2C%20ethereal%20golden%20mist%20tones%2C%20minimal%20epic%20oriental%20composition&width=600&height=840&seq=movie-11-poster&orientation=portrait',
    tags: ['动画', '修仙', '玄幻'],
    updateTime: '2026-08-01',
    isHot: true,
    isNew: true,
    views: 1680000,
  },
  {
    id: 'movie-12',
    title: '欢乐喜剧人第八季',
    englishTitle: 'Top Funny Comedian S8',
    category: 'zongyi',
    year: 2026,
    rating: 8.0,
    region: '中国大陆',
    director: '施嘉宁',
    cast: ['沈腾', '马丽', '贾玲', '岳云鹏'],
    duration: '95分钟/期',
    description: '国内最顶尖的喜剧人同台竞技，用笑声征服观众。小品、相声、脱口秀，各种喜剧形式轮番上阵。本季更有跨界喜剧人加盟，精彩升级，笑料不断。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20variety%20show%20style%2C%20bright%20stage%20performance%20scene%2C%20colorful%20energetic%20lighting%2C%20joyful%20entertaining%20atmosphere%20with%20stage%20spotlights&width=840&height=470&seq=movie-12-cover&orientation=landscape',
    posterImage: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20show%20poster%2C%20stage%20performance%20theme%2C%20bright%20colorful%20energetic%20composition%2C%20minimal%20cheerful%20design&width=600&height=840&seq=movie-12-poster&orientation=portrait',
    tags: ['喜剧', '竞技', '真人秀'],
    updateTime: '2026-07-27',
    isHot: false,
    isNew: true,
    views: 1120000,
  },
];

export const featuredMovies = movies.filter(m => m.isHot).slice(0, 6);
export const latestMovies = movies.filter(m => m.isNew).slice(0, 8);
export const popularMovies = [...movies].sort((a, b) => b.views - a.views).slice(0, 10);

export function getMoviesByCategory(slug: string): Movie[] {
  return movies.filter(m => m.category === slug);
}

export function getMovieById(id: string): Movie | undefined {
  return movies.find(m => m.id === id);
}

export function getCategoryBySlug(slug: string): Category | undefined {
  return categories.find(c => c.slug === slug);
}

export function getRelatedMovies(movie: Movie, limit: number = 6): Movie[] {
  return movies
    .filter(m => m.id !== movie.id && (m.category === movie.category || m.tags.some(t => movie.tags.includes(t))))
    .slice(0, limit);
}